import React, { createContext, useState } from 'react';
import { getGlobal} from 'reactn';
import { useFirestore } from 'reactfire';

export const StoreContext = createContext();

export const StoreProvider = (props) => {


    let firestore = useFirestore();

    const [state, setState] = useState(
        {
            ChiefComplaints_location: {
                LeftEar: {
                    Discharge: {
                        'isDischarge': 'No',
                        'Duration' : '< week',
                        'Onset' : 'Sudden',
                        'Progression' : 'Not Progressive',
                        'Severity' : 'Mild',
                        'Aggravating Factors' : 'Not Known',
                        'Relieving Factors' : 'Not Known',
                        'Causative Factors' : 'Not Known',
                        'Assocaited Symptoms' : 'Not Known',
                        'Treatment Taken' : 'Not Known',
                        'Visual Analog Scale' : '6',
                        'Quantity' : 'Profuse',
                        'Color' : 'Colorless',
                        'Blood Stained' : 'No',
                        'Smell' : 'Not Foul Smelling'
                    }
                }
            }
        }
    );

    const updateState = (params) => {
        let records = [];


        firestore.collection("ChiefComplaints").where("appointment_id", "==", params).get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                records.push({data: doc.data(), id: doc.id});
            });


        }).finally(() => {
            setState({ChiefComplaints_location : records[0].data.ChiefComplaints_location});
            console.log('appointmentId : ',records[0].data.ChiefComplaints_location);

            // setState({ChiefComplaints_location_appointment_id: records.length > 0 ? records[0].data.appointment_id : getGlobal().ChiefComplaints_location_appointment_id});
            // setState({ChiefComplaints_location_id: records.length > 0 ? records[0].id : null});
            // setState({hasFetchedChiefComplaints: true});
        })

    }


    return (
        <StoreContext.Provider value={{
                        state: state, 
                        action: updateState, 
        }}>
        {props.children}
        </StoreContext.Provider>
    )
    
}